import { render } from "./OnlineGivingSetup.vue?vue&type=template&id=1112acb9&scoped=true"
import script from "./OnlineGivingSetup.vue?vue&type=script&lang=js"
export * from "./OnlineGivingSetup.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1112acb9"]])

export default __exports__